import { Directive } from '@angular/core';

/**
 * Content projection slot directive for the `ContainerCardComponent`.
 *
 * Marks the host element as the **title action component** slot, rendered in the
 * top-right area of the card header alongside the card title. Typical usage is a
 * single interactive control such as a sort or filter select.
 *
 * @example
 * <wcg-container-card-title-action-component-wrapper>
 *   <wcg-uni-select placeholder="Sort" [options]="sortOptions" [formField]="sortForm" />
 * </wcg-container-card-title-action-component-wrapper>
 */
@Directive({
  selector: 'wcg-container-card-title-action-component-wrapper',
})
export class ContainerCardTitleActionComponentWrapperDirective {}

/**
 * Content projection slot directive for the `ContainerCardComponent`.
 *
 * Marks the host element as the **title action items** slot, rendered as a full-width
 * row below the main title row in the card header. Use this slot for secondary
 * navigation or filter controls such as tab groups or button-toggle bars.
 *
 * @example
 * <wcg-container-card-title-action-items-wrappers>
 *   <mat-tab-group ... />
 * </wcg-container-card-title-action-items-wrappers>
 */
@Directive({
  selector: 'wcg-container-card-title-action-items-wrappers',
})
export class ContainerCardTitleActionItemsWrapperDirective {}

/**
 * Content projection slot directive for the `ContainerCardComponent`.
 *
 * Marks the host element as the **card content** slot, rendered inside
 * `mat-card-content`. Place the primary body content of the card here.
 *
 * @example
 * <wcg-container-card-content-wrapper>
 *   <wcg-my-data-table [data]="rows" />
 * </wcg-container-card-content-wrapper>
 */
@Directive({
  selector: 'wcg-container-card-content-wrapper',
})
export class ContainerCardContentWrapperDirective {}

/**
 * Content projection slot directive for the `ContainerCardComponent`.
 *
 * Marks the host element as the **card actions** slot, rendered inside
 * `mat-card-actions` at the bottom of the card. Use this for footer-level
 * actions such as "View all" links or action buttons.
 *
 * @example
 * <wcg-container-card-actions-wrapper>
 *   <a href="#" (click)="handleViewAll()">View all →</a>
 * </wcg-container-card-actions-wrapper>
 */
@Directive({
  selector: 'wcg-container-card-actions-wrapper',
})
export class ContainerCardActionsWrapperDirective {}

/**
 * Content projection slot directive for the `ContainerCardComponent`.
 *
 * Marks the host element as the **title menu items** slot. Rendered inline within the
 * card title row when the `showMenuItems` input on `ContainerCardComponent` is `true`.
 * Typical usage is a `mat-button-toggle-group` or similar menu control.
 *
 * @example
 * <wcg-container-card-title-menu-items-wrapper>
 *   <mat-button-toggle-group ... />
 * </wcg-container-card-title-menu-items-wrapper>
 */
@Directive({
  selector: 'wcg-container-card-title-menu-items-wrapper',
})
export class ContainerCardTitleMenuItemsWrapperDirective {}
